export const defaultFieldsTypeOptions = <const>[
  'text',
  'boolean',
  'number',
  'date',
  'currency',
];
export type DefaultFieldsTypeOptions = typeof defaultFieldsTypeOptions[number];

export interface IDefaultFields {
  name: string;
  type: DefaultFieldsTypeOptions;
  createdAt?: Date;
  updatedAt?: Date;
  showOnOnboard?: boolean;
  defaultValue?: string;
  description?: string;
}

export interface IDefaultFieldsApiModel {
  name: string;
  type: DefaultFieldsTypeOptions;
  createdAt?: string;
  description?: string;
  updatedAt?: string;
  showOnOnboard?: boolean;
  defaultValue?: string;
}

export default class DefaultFields implements IDefaultFields {
  public readonly name: string;

  public readonly description?: string;

  public readonly type: DefaultFieldsTypeOptions;

  public readonly createdAt: Date | undefined;

  public readonly updatedAt: Date | undefined;

  public readonly showOnOnboard: boolean | undefined;

  public readonly defaultValue: string | undefined;

  constructor(
    name: string,
    type: DefaultFieldsTypeOptions,
    createdAt?: Date,
    description?: string,
    updatedAt?: Date,
    showOnOnboard?: boolean,
    defaultValue?: string,
  ) {
    this.name = name;
    this.description = description;
    this.type = type;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.showOnOnboard = showOnOnboard;
    this.defaultValue = defaultValue;
  }

  static fromApiModel(apiModel: IDefaultFieldsApiModel): IDefaultFields {
    const { name, description, type, showOnOnboard, defaultValue } = apiModel;

    const createdAt = apiModel.createdAt
      ? new Date(Date.parse(apiModel.createdAt))
      : undefined;
    const updatedAt = apiModel.updatedAt
      ? new Date(Date.parse(apiModel.updatedAt))
      : undefined;

    return new DefaultFields(
      name,
      type,
      createdAt,
      description,
      updatedAt,
      showOnOnboard,
      defaultValue,
    );
  }

  static arrayFromApiModel(arrayApiModel: IDefaultFieldsApiModel[]) {
    const array = arrayApiModel.map(apiModel =>
      DefaultFields.fromApiModel(apiModel),
    );

    return array;
  }
}
